import React from 'react'
import './skills.css'
import html from '../../img/html.png'
import css from '../../img/css.png'
import javascripts from '../../img/javascripts.png'
import react from '../../img/react.png'
// import github from '../../img/github.png'
import node from '../../img/node.png'
import express from '../../img/express.jpg'
import mongoose from '../../img/mongoose.png'

function Skills() {
    return (
        <div className="aligner" id='skills'>
            <h1 className="heading">Skills</h1>
            <h1 className="heading1">Frontend</h1>
        <div className="container">
          <div className="logoWrapper">
            <img  src={html} alt="HTML"  className="logopic"/>
            <span>HTML</span>
          </div>

          <div className="logoWrapper">
          <img  src={css} alt="CSS"  className="logopic"/>
            <span>CSS</span>
          </div>

          <div className="logoWrapper">
          <img  src={javascripts} alt="JavaScript"  className="logopic"/>
            <span>Javascript</span>
          </div>


          <div className="logoWrapper">
          <img  src={react} alt="React"  className="logopic"/>
            <span>React</span>
          </div>
            </div>
            <h1 className="heading1">Backend</h1>
            <div className="container">
          
            
          <div className="logoWrapper">
          <img  src={node} alt="Node"  className="logopic"/>
            <span>Node</span>
          </div>

          <div className="logoWrapper">
          <img  src={express} alt="express"  className="logopic"/>
            <span>Express</span>
          </div>

          <div className="logoWrapper">
          <img  src={mongoose} alt="MongoDB"  className="logopic"/>
            <span>MongoDB</span>
          </div>
        </div>
        </div>
    )
}

export default Skills